import React, { useEffect, useState } from "react";
import { coursesAPI } from "../services/api";
import { useNavigate } from "react-router-dom";
import "../styles/CoursesPage.css";

const CoursesPage = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCourses = async () => {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        alert("❌ لم يتم تسجيل الدخول. الرجاء تسجيل الدخول أولاً.");
        navigate("/login");
        return;
      }

      try {
        const response = await coursesAPI.getAll();
        setCourses(response.data);
      } catch (error) {
        console.error("❌ خطأ أثناء جلب الدورات:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, [navigate]);

  const handleDeleteCourse = async (courseId) => {
    if (window.confirm("هل أنت متأكد أنك تريد حذف هذه الدورة؟")) {
      try {
        await coursesAPI.delete(courseId);
        setCourses((prevCourses) => prevCourses.filter((course) => course.id !== courseId));
        alert("✅ تم حذف الدورة بنجاح.");
      } catch (error) {
        console.error("❌ خطأ أثناء حذف الدورة:", error);
        alert("❌ حدث خطأ أثناء حذف الدورة.");
      }
    }
  };

  return (
    <div className="courses-page">
      <div className="page-header">
        <h2>📚 الدورات المتاحة</h2>
        <button className="btn-primary" onClick={() => navigate("/add-course")}>
          ➕ إضافة دورة جديدة
        </button>
      </div>

      {loading ? (
        <p>⏳ جارٍ تحميل الدورات...</p>
      ) : courses.length > 0 ? (
        <div className="courses-grid">
          {courses.map((course) => (
            <div key={course.id} className="card course-card">
              <div className="course-thumbnail">
                {/* Placeholder for course image */}
                <span>🎓</span>
              </div>
              <div className="course-content">
                <h3 className="course-title">{course.title}</h3>
                <p className="course-description">{course.description}</p>

                <div className="course-meta">
                  <span>📅 {new Date(course.created_at).toLocaleDateString('ar-EG')}</span>
                  {course.teacher_name && <span className="course-teacher">👨‍🏫 أ. {course.teacher_name}</span>}
                </div>

                <div className="course-actions">
                  <button
                    className="btn-outline"
                    onClick={() => navigate(`/Courses/${course.id}`)}
                  >
                    عرض التفاصيل
                  </button>
                  <button
                    className="btn-danger-text"
                    onClick={() => handleDeleteCourse(course.id)}
                  >
                    حذف
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="empty-state">
          <p>⚠️ لا توجد دورات متاحة حاليًا.</p>
          <button className="btn-primary" onClick={() => navigate("/add-course")}>
            ابدأ بإضافة أول دورة
          </button>
        </div>
      )}
    </div>
  );
};

export default CoursesPage;
